import { useQuery } from '@apollo/client';

function useQueryResponse({ query, variables = {}, ssr= false, fetchPolicy = 'network-only'  }) {
  return useQuery(query, {
    variables,
    fetchPolicy,
    ssr
  });
}

export default useQueryResponse;